(() => {

/* Product images are embedded below so this file works on its own. */
const IMG = JSON.parse(document.getElementById("myfak-images").textContent);

const item = (qty, name, detail) => ({ qty, name, detail: detail || '' });

const KITS = {
  myfak: {
    name: 'MyFAK',
    count: '115+',
    countLabel: 'supplies in the MyFAK',
    front: 'myfak-front', frontAlt: 'The MyFAK, closed',
    open: 'myfak-open', openAlt: 'The MyFAK, open flat, showing its folding pages of labeled pouches',
    contents: 'myfak-contents',
    contentsAlt: 'Every supply in the MyFAK laid out flat around the kit: labeled MOD pouches, gauze, bandages, shears, a cold pack and a space blanket',
    mods: [
      ['Burn', '#F26B1D'], ['Blister', '#3BAA4A'], ['Medication', '#F2C200'], ['Hydration', '#1F86D1'],
      ['Sprain & Fracture', '#6A3FA0'], ['Gauze', '#D3222E'], ['Clean & Prep', '#1FB59C'],
      ['Treatment & Relief', '#2E8F84'], ['Wound Closure', '#1A1A1A'], ['Tools', '#1A1A1A']
    ],
    extras: 'Also packed: space blanket, CPR shield, two pairs of gloves, large EMT shears, triangular bandage, elastic bandage, cold pack, saline wash and cloth tape.',
    listNote: "Every item in the standard MyFAK, from My Medic's contents list",
    groups: [
      { name: 'Cuts & bleeding', color: '#D3222E', items: [
        item('1', 'Gauze MOD', '2 non-adherent pads, 3×4 in · 3 non-adherent pads, 2×2 in · 3 gauze pads, 2×2 in · 2 gauze pads, 4×4 in · 2 in and 3 in gauze rolls'),
        item('1', 'SuperSkin assorted bandage pack', '9 bandages, 1×3 in · 3 bandages, 2×4 in'),
        item('1', 'Mini Wound Closure MOD', '3 Secure Strips · 1 tube of liquid skin'),
        item('1', 'Cloth tape', '1 in × 30 ft') ] },
      { name: 'Burns', color: '#F26B1D', items: [
        item('1', 'Burn MOD', '4 burn gel packets · 1 Burnshield dressing, 4×4 in') ] },
      { name: 'Cleaning & skin care', color: '#1FB59C', items: [
        item('1', 'Super Wash', 'Saline wash for wounds or eyes'),
        item('1', 'Clean & Prep MOD', '4 antiseptic wipes · 4 hand sanitizers · 1 iodine prep pad'),
        item('1', 'Treatment & Relief MOD', '3 triple antibiotic ointments · 2 lip balms · 2 sunscreens · 2 sting relief wipes · 1 white petrolatum · 2 hydrocortisone · 2 oral pain relief · 1 ammonia towelette · 1 Friction Frosting chamois butter') ] },
      { name: 'Medication', color: '#F2C200', items: [
        item('1', 'Medication MOD', '4 ibuprofen · 2 APAP (acetaminophen) · 2 aspirin · 2 Diotame (bismuth) · 2 Diphen (diphenhydramine) · 2 Diamode (loperamide) · 2 cold & flu') ] },
      { name: 'Sprains & fractures', color: '#6A3FA0', items: [
        item('1', 'Triangular bandage', 'Arm sling, head dressing or splint binding'),
        item('1', 'Elastic bandage', '2 in roll'),
        item('1', 'Small instant cold pack'),
        item('1', 'Mini Sprain & Fracture MOD', 'Finger splint · Sensi-Wrap, 1 in × 15 ft') ] },
      { name: 'Outdoors', color: '#3BAA4A', items: [
        item('1', 'Space blanket', 'Reflects 90% of body heat'),
        item('1', 'Blister MOD', '3 SuperSkin blister strips'),
        item('1', 'Hydration MOD', '2 KoKos hydration packets · 10 water purification tablets') ] },
      { name: 'CPR & protection', color: '#1F86D1', items: [
        item('1', 'CPR shield'),
        item('2', 'Pairs of disposable gloves') ] },
      { name: 'Tools', color: '#1A1A1A', items: [
        item('1', 'Tool MOD', 'Penlight · tweezers · thermometer · 5 thermometer sheaths · whistle'),
        item('1', 'Large EMT shears', '7.5 in') ] }
    ]
  },
  mini: {
    name: 'MyFAK Mini',
    count: '62+',
    countLabel: 'lifesaving items in the Mini',
    front: 'mini-front', frontAlt: 'The MyFAK Mini, closed',
    open: 'mini-open', openAlt: 'The MyFAK Mini, open flat, showing its folding pages of labeled pouches',
    contents: 'mini-contents',
    contentsAlt: 'Every item in the MyFAK Mini laid out flat around the kit: labeled MOD pouches, shears, a CPR shield and a space blanket',
    mods: [
      ['Burn', '#F26B1D'], ['Blister', '#3BAA4A'], ['Medication', '#F2C200'], ['Hydration', '#1F86D1'],
      ['Sprain & Fracture', '#6A3FA0'], ['Gauze', '#D3222E'], ['Topical', '#1FB59C'],
      ['Wound Closure', '#1A1A1A'], ['Tools', '#1A1A1A']
    ],
    extras: 'Also packed: space blanket, CPR shield, gloves, small EMT shears, saline wash and cloth tape.',
    listNote: "Every item in the standard MyFAK Mini, from My Medic's contents list",
    groups: [
      { name: 'Cuts & bleeding', color: '#D3222E', items: [
        item('1', 'Mini Gauze MOD', '2 non-adherent pads, 2×2 in · 2 gauze pads, 2×2 in · 1 gauze pad, 4×4 in · 1 conforming gauze roll, 2 in'),
        item('1', 'SuperSkin assorted bandage pack', '9 bandages, 1×3 in · 3 bandages, 2×4 in'),
        item('1', 'Mini Wound Closure MOD', '3 Secure Strips · 1 tube of liquid skin'),
        item('1', 'Cloth tape', '1 in × 30 ft') ] },
      { name: 'Burns', color: '#F26B1D', items: [
        item('1', 'Mini Burn MOD', '3 burn gel packets') ] },
      { name: 'Cleaning & skin care', color: '#1FB59C', items: [
        item('1', 'Super Wash', 'Saline wash for wounds or eyes'),
        item('1', 'Mini Topical MOD', '2 antiseptic wipes · hand sanitizer · 2 triple antibiotic ointments · lip balm · sunscreen · hydrocortisone · oral pain relief · Friction Frosting chamois butter') ] },
      { name: 'Medication', color: '#F2C200', items: [
        item('1', 'Mini Medication MOD', 'Ibuprofen · APAP (acetaminophen) · aspirin · Diotame (bismuth) · Medi-Meclizine (meclizine) · Diphen (diphenhydramine) · cold & flu') ] },
      { name: 'Sprains & fractures', color: '#6A3FA0', items: [
        item('1', 'Mini Sprain & Fracture MOD', 'Finger splint · Sensi-Wrap, 1 in × 15 ft') ] },
      { name: 'Outdoors', color: '#3BAA4A', items: [
        item('1', 'Space blanket', 'Reflects 90% of body heat'),
        item('1', 'Blister MOD', '3 SuperSkin blister strips'),
        item('1', 'Hydration MOD', '2 KoKos hydration packets · 10 water purification tablets') ] },
      { name: 'CPR & protection', color: '#1F86D1', items: [
        item('1', 'CPR shield'),
        item('1', 'Pair of disposable gloves') ] },
      { name: 'Tools', color: '#1A1A1A', items: [
        item('1', 'Mini Tool MOD', 'Penlight · tweezers · whistle'),
        item('1', 'Small EMT shears') ] }
    ]
  }
};

const REFILLS = [
  { key: 'bandages', label: 'Bandages', band: '#D3222E', ink: '#FFFFFF', pouch: 'SuperSkin', sub: 'Assorted bandages', plain: 'bandage', title: 'SuperSkin bandages',
    use: 'Patch up the scraped knee at the trailhead. The bandage pack comes home a little thinner.', video: 'A short training video on using the bandages.' },
  { key: 'burn', label: 'Burn', band: '#F26B1D', ink: '#141516', pouch: 'Burn | MOD', sub: 'Minor burns', plain: 'Burn', title: 'Burn MOD',
    use: 'Cool the burn from the camp stove and cover it. A few gel packets are gone.', video: 'A short training video on using the Burn MOD.' },
  { key: 'gauze', label: 'Gauze', band: '#D3222E', ink: '#FFFFFF', pouch: 'Gauze | MOD', sub: 'Bleeding', plain: 'Gauze', title: 'Gauze MOD',
    use: 'Press gauze over the cut until the bleeding slows. The pads are spent.', video: 'A short training video on using the Gauze MOD.' },
  { key: 'medication', label: 'Medication', band: '#F2C200', ink: '#141516', pouch: 'Medication | MOD', sub: 'Over-the-counter', plain: 'Medication', title: 'Medication MOD',
    use: 'Hand out ibuprofen after the long climb. The pouch is running low.', video: 'A short training video on using the Medication MOD.' },
  { key: 'blister', label: 'Blister', band: '#3BAA4A', ink: '#141516', pouch: 'Blister | MOD', sub: 'Hot spots', plain: 'Blister', title: 'Blister MOD',
    use: 'Cover the hot spot before it turns into a blister. One strip left.', video: 'A short training video on using the Blister MOD.' },
  { key: 'sprain', label: 'Sprain & Fracture', band: '#6A3FA0', ink: '#FFFFFF', pouch: 'Sprain & Fracture', sub: 'MOD', plain: 'Sprain & Fracture', title: 'Sprain & Fracture MOD',
    use: 'Wrap the rolled ankle and splint the jammed finger. The wrap stays on the ankle.', video: 'A short training video on using the Sprain & Fracture MOD.' }
];

const state = { size: 'myfak', open: false, listOpen: false, scan: 'bandages' };

const $ = (sel) => document.querySelector(sel);
const $$ = (sel) => Array.from(document.querySelectorAll(sel));
const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const setImg = (el, key) => { if (IMG[key]) el.src = IMG[key]; };

function renderKit() {
  const kit = KITS[state.size];
  $$('[data-size]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.size === state.size)));
  const closed = $('#stage-closed');
  const open = $('#stage-open');
  setImg(closed, kit.front); closed.alt = kit.frontAlt;
  setImg(open, kit.open); open.alt = kit.openAlt;
  $('#count').textContent = kit.count;
  $('#count-label').textContent = kit.countLabel;
  const contents = $('#contents-img');
  setImg(contents, kit.contents); contents.alt = kit.contentsAlt;
  $('#contents-cap').textContent = 'Fig. 4 — The ' + kit.name + ', everything inside laid flat';
  $('#mods').innerHTML = kit.mods.map(([label, color]) =>
    '<li><span class="swatch" style="--c:' + color + '" aria-hidden="true"></span><span>' + esc(label) + '</span></li>').join('');
  $('#extras').textContent = kit.extras;
  $('#packing-note').textContent = kit.listNote;
  $('#packing-list').innerHTML = kit.groups.map((g) =>
    '<div class="pack-group"><h4><span class="swatch" style="--c:' + g.color + '" aria-hidden="true"></span><span>' + esc(g.name) + '</span></h4>' +
    '<ul class="pack-items">' + g.items.map((it) =>
      '<li><span class="qty">' + esc(it.qty) + '</span><span><span class="item-name">' + esc(it.name) + '</span>' +
      (it.detail ? '<span class="item-detail">' + esc(it.detail) + '</span>' : '') + '</span></li>').join('') +
    '</ul></div>').join('');
  renderOpen();
}

function renderOpen() {
  const kit = KITS[state.size];
  $('#stage').classList.toggle('is-open', state.open);
  $('#stage-closed').setAttribute('aria-hidden', String(state.open));
  $('#stage-open').setAttribute('aria-hidden', String(!state.open));
  $('#open-toggle').setAttribute('aria-pressed', String(state.open));
  $('#open-label').textContent = state.open ? 'Close the kit' : 'Open the kit';
  $('#stage-cap').textContent = 'Fig. 3 — ' + kit.name + (state.open ? ', open' : ', closed');
}

function renderList() {
  $('#packing-toggle').setAttribute('aria-expanded', String(state.listOpen));
  $('#packing-title').textContent = state.listOpen ? 'Hide the packing list' : 'See the full packing list';
  $('#packing-list').hidden = !state.listOpen;
}

function renderRefill() {
  const r = REFILLS.find((x) => x.key === state.scan) || REFILLS[0];
  $$('#chips .chip').forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.scan === r.key)));
  const demo = $('#demo');
  demo.style.setProperty('--band', r.band);
  demo.style.setProperty('--band-ink', r.ink);
  $('#pouch-sub').textContent = r.sub;
  $('#pouch-name').textContent = r.pouch;
  $('#screen-title').textContent = r.title;
  $('#video-line').textContent = r.video;
  $('#use-line').textContent = r.use;
  $('#demo-cap').textContent = 'Fig. 5 — Scanning the ' + r.plain + ' pouch';
}

// Static images
$$('img[data-img]').forEach((img) => setImg(img, img.dataset.img));

// Refill chips
$('#chips').innerHTML = REFILLS.map((r) =>
  '<button class="chip" type="button" data-scan="' + r.key + '" aria-pressed="false"><span class="swatch" style="--c:' + r.band + '" aria-hidden="true"></span><span>' + esc(r.label) + '</span></button>').join('');

// Events
$$('[data-size]').forEach((b) => b.addEventListener('click', () => { state.size = b.dataset.size; renderKit(); }));
$('#open-toggle').addEventListener('click', () => { state.open = !state.open; renderOpen(); });
$('#packing-toggle').addEventListener('click', () => { state.listOpen = !state.listOpen; renderList(); });
$$('#chips .chip').forEach((c) => c.addEventListener('click', () => { state.scan = c.dataset.scan; renderRefill(); }));

renderKit();
renderList();
renderRefill();

})();
